import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconUserAdd$1 = /*@__PURE__*/ proxyCustomElement(class WppIconUserAdd extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-user-add", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M14.5475 11.0933C17.007 11.0933 19.0009 13.0871 19.0009 15.5466C19.0009 18.0062 17.007 20 14.5475 20C12.088 20 10.0942 18.0062 10.0942 15.5466C10.0942 13.0871 12.088 11.0933 14.5475 11.0933ZM10.1122 12.7121C9.87194 13.0873 9.67799 13.4949 9.53839 13.9269L3.82092 13.9272C3.48603 13.9272 3.21455 14.1987 3.21455 14.5335V15.0013C3.21455 15.435 3.36929 15.8545 3.65096 16.1843C4.66576 17.3727 6.25754 17.9766 8.47475 17.9766C8.95769 17.9766 9.41102 17.948 9.83524 17.8909C10.0338 18.2916 10.2828 18.6629 10.5733 18.9972C9.92917 19.1269 9.22888 19.1912 8.47475 19.1912C5.92754 19.1912 3.99558 18.4582 2.72734 16.9731C2.2579 16.4233 2 15.7242 2 15.0013V14.5335C2 13.5279 2.81525 12.7126 3.82092 12.7126L10.1122 12.7121ZM14.5475 12.7127L14.4747 12.7192C14.3095 12.7492 14.1792 12.8795 14.1492 13.0447L14.1427 13.1175L14.1419 15.1418H12.1216L12.0488 15.1483C11.8835 15.1783 11.7532 15.3086 11.7232 15.4739L11.7167 15.5466L11.7232 15.6194C11.7532 15.7847 11.8835 15.915 12.0488 15.945L12.1216 15.9515H14.1419L14.1427 17.9757L14.1492 18.0485C14.1792 18.2138 14.3095 18.3441 14.4747 18.3741L14.5475 18.3806L14.6203 18.3741C14.7855 18.3441 14.9158 18.2138 14.9458 18.0485L14.9524 17.9757L14.9516 15.9515H16.9798L17.0526 15.945C17.2178 15.915 17.3481 15.7847 17.3781 15.6194L17.3846 15.5466L17.3781 15.4739C17.3481 15.3086 17.2178 15.1783 17.0526 15.1483L16.9798 15.1418H14.9516L14.9524 13.1175L14.9458 13.0447C14.9158 12.8795 14.7855 12.7492 14.6203 12.7192L14.5475 12.7127ZM8.47475 3C10.7107 3 12.5233 4.81258 12.5233 7.04851C12.5233 9.28444 10.7107 11.097 8.47475 11.097C6.23882 11.097 4.42624 9.28444 4.42624 7.04851C4.42624 4.81258 6.23882 3 8.47475 3ZM8.47475 4.21455C6.9096 4.21455 5.64079 5.48336 5.64079 7.04851C5.64079 8.61366 6.9096 9.88247 8.47475 9.88247C10.0399 9.88247 11.3087 8.61366 11.3087 7.04851C11.3087 5.48336 10.0399 4.21455 8.47475 4.21455Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-user-add-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-user-add", "wpp-icon-user-add-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-user-add-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-user-add-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconUserAdd$1);
      }
      break;
  } });
}

const WppIconUserAdd = WppIconUserAdd$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconUserAdd, defineCustomElement };
